import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';

export const SIZE = {
	XS: 'xs',
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
};

export const HOVER_CURSOR = {
	POINTER: 'pointer',
	DEFAULT: 'default',
};

const StyledSpan = Styled.span`
	display: flex;
	height: ${({size}) => size + 'px'};
	width: ${({size}) => size + 'px'};
	align-items: center;
	> svg {
		path {
			fill: ${({color, overrideColor}) => overrideColor && color};
		}
	}
	&:hover	{ 
		${({hoverCursor}) => hoverCursor === HOVER_CURSOR.POINTER && `cursor: pointer; `}
		> svg {
			path {
				fill: ${({color, hoverColor}) => (hoverColor ? hoverColor : color)};
			}
		}
	}
`;

export const BaseIcon = ({
	children,
	size = SIZE.MEDIUM,
	color = '#4C4C58',
	overrideColor,
	hoverColor,
	hoverCursor = HOVER_CURSOR.DEFAULT,
}) => {
	const getSize = size => {
		switch (size) {
			case SIZE.XS:
				return 12;
			case SIZE.SMALL:
				return 16;
			case SIZE.MEDIUM:
				return 20;
			case SIZE.LARGE:
				return 24;
		}
	};
	return (
		<StyledSpan
			size={getSize(size)}
			color={color}
			overrideColor={overrideColor}
			hoverColor={hoverColor}
			hoverCursor={hoverCursor}
		>
			{children}
		</StyledSpan>
	);
};

export const iconPropTypes = {
	children: PropTypes.node,
	size: PropTypes.oneOf(Object.values(SIZE)),
	color: PropTypes.string,
	overrideColor: PropTypes.bool,
	hoverColor: PropTypes.string,
};

export const iconDefaultProps = {
	size: SIZE.MEDIUM,
	color: '#4C4C58',
	overrideColor: true,
	hoverColor: '#4C4C58',
};

BaseIcon.SIZE = SIZE;
BaseIcon.propTypes = iconPropTypes;
BaseIcon.defaultProps = iconPropTypes;
